export default () => ({
  notification: null,
});
